import { useTheme } from 'styled-components';

import SearchBarDateRangeInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarRangeDatePickerInput/SearchBarDateRangePickerInput';
import SearchBarSingleDatePickerInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarSingleDatePickerInput/SearchBarSingleDatePickerInput';
import { DayPickerRangeControllerProps } from '@components/DatePicker/DateRangePicker/DateRangePicker';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { SearchBarInputError } from '@components/views/flight/types';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';
import {
  SearchBarInputProps,
  SearchBarPopoverProps,
} from '@components/ui/search/SearchBarInput/SearchBarInputInterface';

import { isFlightReturnDateOutsideRange } from './utils';

export interface SearchBarRangeDatePickerProps
  extends Pick<
      DayPickerRangeControllerProps,
      'startDate' | 'endDate' | 'onDatesChange' | 'minimumNights' | 'onReady'
    >,
    Pick<SearchBarInputProps, 'popoverContentReady'> {
  error?: SearchBarInputError | boolean;
  popoverProps?: SearchBarPopoverProps;
  inputComponent:
    | 'shopAndFlyHomePageFlight'
    | 'shopAndFlyHomePageHotel'
    | 'setur';
}

const SearchBarRangeDatePicker = ({
  startDate,
  endDate,
  onDatesChange,
  minimumNights,
  error,
  inputComponent,
  onReady,
  popoverContentReady,
  popoverProps,
}: SearchBarRangeDatePickerProps) => (
  <LocationAnimationErrorBox hasError={!!error}>
    <SearchBarDateRangeInput
      dateProps={{
        minimumNights,
        startDate,
        endDate,
        onDatesChange,
        isOutsideRange: (day) => isFlightReturnDateOutsideRange(day, startDate),
        onReady,
      }}
      placeholder='Gidiş - Dönüş Tarihleri'
      label='Gidiş-Dönüş Tarihiniz?'
      inputComponent={inputComponent}
      popoverContentReady={popoverContentReady}
      popoverProps={popoverProps}
    />
  </LocationAnimationErrorBox>
);

export interface SearchBarSingleDatePickerProps
  extends Pick<
      DayPickerSingleDateControllerProps,
      'date' | 'onDateChange' | 'onReady'
    >,
    Pick<SearchBarInputProps, 'popoverContentReady'> {
  error?: SearchBarInputError | boolean;
  popoverProps?: SearchBarPopoverProps;
  inputComponent:
    | 'shopAndFlyHomePageFlight'
    | 'shopAndFlyHomePageHotel'
    | 'setur';
}

const SearchBarSingleDatePicker = ({
  date,
  onDateChange,
  error,
  inputComponent,
  onReady,
  popoverContentReady,
  popoverProps,
}: SearchBarSingleDatePickerProps) => {
  const theme = useTheme();
  const { containerStyle, ...otherPopoverProps } = popoverProps ?? {};

  return (
    <SearchBarSingleDatePickerInput
      placeholder='Gidiş Tarihi'
      label='Gidiş Tarihiniz?'
      error={Boolean(error)}
      dateProps={{
        date,
        onDateChange,
        onReady,
      }}
      inputComponent={inputComponent}
      popoverContentReady={popoverContentReady}
      popoverProps={{
        ...otherPopoverProps,
        containerStyle: {
          width: '620px',
          zIndex: String(theme.zIndices.timePicker),
          ...containerStyle,
        },
      }}
    />
  );
};

export { SearchBarRangeDatePicker, SearchBarSingleDatePicker };
